<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <v-app>
        <resizable-page>
          <template v-slot:table="tableProps">
            <v-card>
              <!-- <v-card-title>
      Client Master List
    </v-card-title> -->
              <v-card-title>
                <v-btn
                  color="primary"
                  dark
                  class="ma-2"
                  @click="addData()"
                  v-if="role.create"
                >
                  Add PKO
                </v-btn>
                <v-menu>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      dark
                      class="ma-2"
                      v-bind="attrs"
                      v-on="on"
                    >
                      Export To XLS
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item link>
                      <downloadExcel
                        class="btn"
                        :fields="field_export"
                        :worksheet="worksheetName"
                        :name="fileName"
                        :fetch="
                          () => {
                            return dataExportBefore('all');
                          }
                        "
                      >
                        All Record
                      </downloadExcel>
                    </v-list-item>
                    <v-list-item link>
                      <downloadExcel
                        class="btn"
                        :data="exportDisplayedPage"
                        :fields="field_export"
                        :worksheet="worksheetName"
                        :name="fileName"
                      >
                        Displayed record
                      </downloadExcel>
                    </v-list-item>
                    <v-list-item link>
                      <downloadExcel
                        class="btn"
                        :fields="field_export"
                        :worksheet="worksheetName"
                        :name="fileName"
                        :fetch="
                          () => {
                            return dataExportBefore('filter');
                          }
                        "
                      >
                        All filtered record
                      </downloadExcel>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <div class="d-flex flex-wrap">
                  <!-- filter date -->
                  <!-- <div class="shadow d-flex">
                    <div class="mt-5 mx-5">
                      <input
                        type="date"
                        class="form-control"
                        placeholder="Username"
                        aria-label="Username"
                        aria-describedby="basic-addon1"
                      />
                    </div>
                    <p class="mt-5 fs-small">s/d</p>
                    <div class="mt-5 mx-5">
                      <input
                        type="date"
                        class="form-control"
                        placeholder="Username"
                        aria-label="Username"
                        aria-describedby="basic-addon1"
                      />
                    </div>
                    <v-btn
                      :disabled="!search"
                      class="mt-5"
                      small
                      color="primary"
                    >
                      <v-icon>mdi-calendar-filter</v-icon>
                    </v-btn>
                  </div> -->
                  <v-select
                    style=" max-width: 150px;"
                    :items="option_filter"
                    label="Select"
                    v-model="searchCategory"
                    @change="search = ''"
                    item-text="text"
                    item-value="value"
                    class="ma-2"
                    hide-details
                  >
                  </v-select>
                  <v-text-field
                    :disabled="!searchCategory"
                    v-model="search"
                    label="Search"
                    class="ma-2"
                    single-line
                    hide-details
                  >
                  </v-text-field>
                  <v-btn
                    :disabled="!search"
                    class="mt-5"
                    small
                    color="primary"
                    @click="searchButton"
                  >
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="searchValue"
                    class="mt-5 ml-1"
                    dark
                    small
                    color="red"
                    @click="clearSearchButton"
                    >Clear</v-btn
                  >
                </div>
                <!-- <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field> -->
              </v-card-title>
              <v-data-table
                mobile-breakpoint
                :headers="headers"
                :items="table"
                :loading="loadTable"
                loading-text="Loading... Please wait"
                @current-items="getFiltered"
                ref="vTable"
                :height="tableProps.tableHeight"
                fixed-header
                :options.sync="options"
                :server-items-length="totalDataTable"
                :page="page"
                :pageCount="numberOfPages"
                :footer-props="{ 'items-per-page-options': [15, 25, 50] }"
              >

                <template v-slot:[`item.vehicle_plate_no`]="{ item }">
                  <router-link v-on:click.native="vehiclePKODetail(item.pko_vehicle.id)" to="">
                    <span v-if="item.pko_vehicle">{{ item.pko_vehicle.vehicle_plate_no }}</span>
                  </router-link>
                </template>

                <template v-slot:[`item.driver_no`]="{ item }">
                  <router-link v-on:click.native="driverPKODetail(item.pko_driver.id)" to="">
                    <span v-if="item.pko_driver">{{ item.pko_driver.driver_no }}</span>
                  </router-link>
                </template>
                
                <template v-slot:[`header.pko_status`]="{ header }">
                  <v-select
                    style=" font-size:10px;"
                    :items="optionStatus"
                    :label="header.text"
                    v-model="valueStatus"
                    @change="getList"
                    item-text="text"
                    item-value="value"
                    class="ma-2"
                    hide-details
                  >
                  </v-select>
                </template>

                <template v-slot:[`header.payment_plan_name`]="{ header }">
                  <v-select
                    style=" font-size:10px;"
                    :items="optionPaymentPlan"
                    :label="header.text"
                    v-model="valuePaymentPlan"
                    @change="getList"
                    item-text="payment_plan_name"
                    item-value="id"
                    class="ma-2"
                    hide-details
                  >
                  </v-select>
                </template>

                <template v-slot:[`header.pko_type`]="{ header }">
                  <v-select
                    style=" font-size:10px;"
                    :items="optionPkoType"
                    :label="header.text"
                    v-model="valuePkoType"
                    @change="getList"
                    item-text="text"
                    item-value="value"
                    class="ma-2"
                    hide-details
                  >
                  </v-select>
                </template>

                <template v-slot:[`item.payment_plan_name`]="{ item }">
                  <span v-if="item.pko_payment_plant">{{ item.pko_payment_plant.payment_plan_name }}</span>
                </template>

                <!-- <template v-slot:[`item.vehicle_plate_no`]="{ item }">
                  <span v-if="item.pko_vehicle">{{
                    item.pko_vehicle.vehicle_plate_no
                  }}</span>
                </template> -->

                <template v-slot:[`item.vehicle_door_no`]="{ item }">
                  <span v-if="item.pko_vehicle">{{
                    item.pko_vehicle.vehicle_door_no
                  }}</span>
                </template>

                <!-- <template v-slot:[`item.driver_no`]="{ item }">
                  <span v-if="item.pko_driver">{{
                    item.pko_driver.driver_no
                  }}</span>
                </template> -->

                <template v-slot:[`item.driver_name`]="{ item }">
                  <span v-if="item.pko_driver">{{
                    item.pko_driver.driver_name
                  }}</span>
                </template>

                
                <template v-slot:[`item.pko_type`]="{ item }">
                  <span v-if="item.pko_type == 1">New</span>
                  <span v-if="item.pko_type == 2">Replacement</span>
                </template>

                <template v-slot:[`item.pko_status`]="{ item }">
                  <span v-if="item.pko_status == 0">Registered</span>
                  <span v-if="item.pko_status == 1">Waiting Approval</span>
                  <span v-if="item.pko_status == 2">Rejected</span>
                  <span v-if="item.pko_status == 3">Active</span>
                  <span v-if="item.pko_status == 4">Payment Completed</span>
                  <span v-if="item.pko_status == 5">Terminate By Payment</span>
                  <span v-if="item.pko_status == 6">Change to Ownership</span>
                </template>
                <!-- <template v-slot:[`item.detail`]="{ item }">
          <router-link :to="{name: 'Detail PKO', params: { id: item.id }}" class="btn btn-primary">Detail
          </router-link>
    </template> -->

                <template v-slot:[`item.actions`]="{ item }">
                  <v-menu offset-x>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        dark
                        x-small
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon dark x-small>
                          mdi-format-list-bulleted-square
                        </v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="detailPko(item.id)">
                        <v-list-item-title x-small>Detail</v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="
                          role.update &&
                            (item.pko_status == 0 || item.pko_status == 2)
                        "
                        @click="editPko(item.id)"
                      >
                        <v-list-item-title x-small>Edit</v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="role.delete && item.pko_status == 0"
                        @click="deleteConfirmation(item.id)"
                      >
                        <v-list-item-title x-small>Delete</v-list-item-title>
                      </v-list-item>
                      <!-- <v-list-item
                        v-if="
                          role.requester &&
                            item.pko_status == 3
                        "
                        @click="createPkoOwnership(item.id)"
                      >
                        <v-list-item-title x-small>Create Ownership</v-list-item-title>
                      </v-list-item> -->
                      <v-list-item
                        v-if="role.create && item.pko_status == 5"
                        @click="replacementPko(item.id)"
                      >
                        <v-list-item-title x-small
                          >Replacement</v-list-item-title
                        >
                      </v-list-item>
                      <!-- <v-list-item
                        v-if="item.pko_status == 3"
                        @click="downloadAgreementDoc(item.id, item)"
                      >
                        <v-list-item-title x-small
                          >Download Agreement Document</v-list-item-title
                        >
                      </v-list-item> -->

                      <!-- <v-list-item  @click="modalOpenEditFormCity(item.id)">
            <v-list-item-title x-small>Edit</v-list-item-title>
          </v-list-item>
          <v-list-item  @click="deleteConfirmation(item.id)">
            <v-list-item-title >Delete</v-list-item-title>
          </v-list-item> -->
                    </v-list>
                  </v-menu>
                </template>
              </v-data-table>
            </v-card>
          </template>
        </resizable-page>
      </v-app>
      <modal ref="modalVehicleDetail">
        <template v-slot:body>
          <detail-vehicle :data_id="$refs.modalVehicleDetail.data"/>
        </template>
      </modal>
      <modal ref="modalDriverDetail">
        <template v-slot:body>
          <detail-driver :data_id="$refs.modalDriverDetail.data"/>
        </template>
      </modal>
      <modal ref="modalDetailPage">
        <template v-slot:body>
          <detail-pko :data_id="$refs.modalDetailPage.data" />
        </template>
      </modal>
      <modal ref="modalAddPage">
        <template v-slot:header>
          <div style="text-align:center; margin:auto;">
            <h3>ADD PKO</h3>
          </div>
          <md-button
            class="md-icon-button md-dense md-round"
            @click="modalCloseAdd()"
          >
            <md-icon>close</md-icon>
          </md-button>
        </template>
        <template v-slot:body>
          <add-pko />
        </template>
      </modal>
      <modal ref="modalEditPage">
        <template v-slot:header>
          <div style="text-align:center; margin:auto;">
            <h3>EDIT PKO</h3>
          </div>
          <md-button
            class="md-icon-button md-dense md-round"
            @click="modalCloseEdit()"
          >
            <md-icon>close</md-icon>
          </md-button>
        </template>
        <template v-slot:body>
          <edit-pko :data_id="$refs.modalEditPage.data" />
        </template>
      </modal>
      <modal ref="modalCreatePkoOwnershipPage">
        <template v-slot:header>
          <div style="text-align:center; margin:auto;">
          <h3 >CREATE PKO</h3>
          </div>
          <md-button class="md-icon-button md-dense md-round"  @click="modalCloseCreatePkoOwnership()">
            <md-icon >close</md-icon>
          </md-button>
        </template>
        <template v-slot:body >
          <create-pko-ownership :data_id="$refs.modalCreatePkoOwnershipPage.data"/>
        </template>
      </modal>

      <modal ref="modalReplacementPage">
        <template v-slot:header>
          <div style="text-align:center; margin:auto;">
            <h3>REPLACEMENT PKO BLACK PLATE</h3>
          </div>
          <md-button
            class="md-icon-button md-dense md-round"
            @click="modalCloseReplacement()"
          >
            <md-icon>close</md-icon>
          </md-button>
        </template>
        <template v-slot:body>
          <replacement-pko :data_id="$refs.modalReplacementPage.data" />
        </template>
      </modal>
    </div>
  </div>
</template>

<script>
import vuetify from "@/plugins/vuetify";
import { ResizablePage } from "@/components";
import Vue from "vue";
import VueSweetalert2 from "vue-sweetalert2";
import DetailPko from "@/pages/Dashboard/Fms/Pko/DetailPPage.vue";
import AddPko from "@/pages/Dashboard/Fms/Pko/AddPPage.vue";
import EditPko from "@/pages/Dashboard/Fms/Pko/EditPPage.vue";
import DetailDriver from "@/pages/Dashboard/Fms/Driver/DetailDPage.vue";
import { Modal } from "@/components";
import Swal from "sweetalert2";
import JsonExcel from "vue-json-excel";

Vue.use(VueSweetalert2);
const toLower = (text) => {
  var rt = "";
  if (text) {
    rt = text.toString().toLowerCase();
  }
  return rt;
};

export default {
  components: {
    downloadExcel: JsonExcel,
    ResizablePage,
    "detail-pko": DetailPko,
    "add-pko": AddPko,
    "edit-pko": EditPko,
    // "detail-vehicle": DetailVehicle,
    "detail-driver": DetailDriver,
    Modal,
  },
  vuetify,
  data: () => ({
    role: "",
    optionPaymentPlan: null,
    valuePaymentPlan: 0,
    mounted: true,
    loadTable: false,
    page: 1,
    options: {},
    totalDataTable: 0,
    numberOfPages: 0,
    searchValue: null,
    searchCategory: null,
    option_filter: [
      { text: "Pko No", value: "pko_no" },
      { text: "Vehicle No", value: "vehicle_door_no" },
      { text: "Plate No", value: "vehicle_plate_no" },
      { text: "Driver No", value: "driver_no" },
      { text: "Driver Name", value: "driver_name" },
    ],
    role: "",
    search: "",
    valueStatus: "",
    optionStatus: [
      { text: "All", value: "" },
      { text: "Change to Ownership", value: "6" },
      { text: "Terminated By Payment", value: "5" },
      { text: "Payment Completed", value: "4" },
      { text: "Active", value: "3" },
      { text: "Rejected", value: "2" },
      { text: "Waiting Approval", value: "1" },
      { text: "Registered", value: "0" },
    ],
    valuePkoType: "",
    optionPkoType: [
      { text: "All", value: "" },
      { text: "Replacement", value: "2" },
      { text: "New", value: "1" },
    ],
    headers: [
      { text: "Actions", align: "start", value: "actions", sortable: false },
      // { text: 'Business Unit', value: 'pko_business_unit' , sortable: false },
      { text: "Pko No", value: "pko_no", align: "left" },
      { text: "Pko Type", value: "pko_type", align: "left", sortable: false, width:'150' },
      { text: "Payment Plant", value: "payment_plan_name", sortable: false, width:'150' },
      { text: "Start Date", value: "pko_start_date", align: "center", width:'150' },
      { text: "Vehicle No", value: "vehicle_door_no", align: "center" },
      { text: "Plate No", value: "vehicle_plate_no", align: "center" },
      { text: "Driver No", value: "driver_no", align: "center" },
      { text: "Driver Name", value: "driver_name", align: "left", width:'200' },
      { text: "Status", value: "pko_status", sortable: false, width:'200' },
      { text: "Created At", value: "created_at", width:'200' },
      // { text: 'Priority', value: 'city_priority', align: 'center' },
      // { text: 'Actions', value: 'actions', align: 'center', sortable: false },
    ],
    table: [],
    worksheetName: "PKO",
    fileName: "PKO.xls",
    exportDisplayedPage: [],
    exportAllFitered: [],
    field_export: {
      "No": "no",
      "PKO No": "pko_no",
      "Start Date": "pko_start_date",
      "Payment Plan": "payment_plan",
      "Total Payable": "pko_total_payable",
      "PKO Status": "pko_status",
      "Driver Name": "driver_name",
      "Driver KIP No": "driver_no",
      "Vehicle Plate No": "vehicle_plate_no",
      "Vehicle Vehicle No": "vehicle_door_no",
      "PKO Remark": "pko_remark",
      created_at: "created_at",
      updated_at: "updated_at",
    },
  }), 

  watch: {
    options: {
      handler() {
        if (!this.mounted) {
          this.getList();
        }
      },
    },
    deep: true,
  },
  async mounted() {
     //set refs in root saat page terbuka, agar fungsi di page ini bisa di panggil dari page lain
    this.$root.$refs.ListPkoPage = this;
    //check saat page terbuka apakah ada params 
    if(this.$route.params.id){
      //open detail
      this.detailPko(this.$route.params.id)
    }
    //get
    //get list role dan permission current user
    this.role = await this.$store.getters["role_permission/route_filter"];
    this.getList();
    this.mounted = false;
  },
  methods: {

    createPkoOwnership(id){
      this.$refs.modalCreatePkoOwnershipPage.openModal({id:id, mode:"pkobp"})
    },
    modalCloseCreatePkoOwnership(){
      this.$refs.modalCreatePkoOwnershipPage.closeModal()
      this.getList();
    },

    modalCloseDetail() {
      this.$refs.modalDetailPage.closeModal();
      this.getList();
    },

    async getList() {
      this.loadTable = true;
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      console.log(this.options);
      let pageNumber = page;

      let itemsPerPageNumber = itemsPerPage;

      var query = { page: { number: pageNumber, size: itemsPerPageNumber } };

      if (sortBy.length != 0) {
        var sort = sortBy[0];
        if (sortDesc[0]) {
          sort = "-" + sortBy[0];
        }
        query.sort = sort;
      }

      if (this.searchValue && this.searchCategory) {
        if (query.filter) {
          Object.assign(query.filter, {
            [this.searchCategory]: this.searchValue,
          });
        } else {
          query.filter = { [this.searchCategory]: this.searchValue };
        }
      }

      if (this.valuePaymentPlan != 0) {
        if (query.filter) {
          Object.assign(query.filter, {
            payment_plan_name: this.valuePaymentPlan,
          });
        } else {
          query.filter = { payment_plan_name: this.valuePaymentPlan };
        }
      }

      if (this.valueStatus != "") {
        if (query.filter) {
          Object.assign(query.filter, { pko_status: this.valueStatus });
        } else {
          query.filter = { pko_status: this.valueStatus };
        }
      }

      if (this.valuePkoType != "") {
        if (query.filter) {
          Object.assign(query.filter, { pko_type: this.valuePkoType });
        } else {
          query.filter = { pko_type: this.valuePkoType };
        }
      }

      await this.$store.dispatch("fms_pko/list", query);
      // if (
      //   (await this.$store.getters["role/list"]) &&
      //   (await this.$store.getters["role/list"].length) != 0
      // ) {
      this.table = await this.$store.getters["fms_pko/list"];
      var pageMeta = await this.$store.getters["fms_pko/page"];
      // }
      // else{
      //   this.table = []
      // }
      this.totalDataTable = pageMeta.total;
      this.numberOfPages = pageMeta["to"];
      this.loadTable = false;
    },

    driverPKODetail(driver_id){
      this.$refs.modalDriverDetail.openModal({ id : driver_id , mode:"PKOBP"})
    },

    closeDriverPKODetail(){
      this.$refs.modalDriverDetail.closeModal();
      // this.getList();

    },

    vehiclePKODetail(vehicle_id){
      this.$refs.modalVehicleDetail.openModal({ id : vehicle_id , mode:"PKOBP"})
    },

    closeVehiclePKODetail(){
      this.$refs.modalVehicleDetail.closeModal();
      // this.getList();

    },

    detailPko(id) {
      this.$refs.modalDetailPage.openModal({ id: id });
    },

    editPko(id) {
      this.$refs.modalEditPage.openModal({ id: id });
    },

    addData() {
      this.$refs.modalAddPage.openModal();
    },

    modalCloseAdd() {
      this.$refs.modalAddPage.closeModal();
      this.getList();
    },

    modalCloseEdit() {
      this.$refs.modalEditPage.closeModal();
      this.getList();
    },

    replacementPko(id) {
      this.$refs.modalReplacementPage.openModal({ id: id });
    },

    modalCloseReplacement() {
      this.$refs.modalReplacementPage.closeModal();
      this.getList();
    },

    deleteConfirmation(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You wont be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.deletePko(id);
        }
      });
    },

    // fungsi delete data
    async deletePko(id) {
      try {
        //kirim data ke server
        await this.$store.dispatch("fms_pko/destroy", id);
        //panggil alert succes
        await this.$store.dispatch(
          "alerts/success",
          "PKO data delete successfully."
        );
        //kembali ke page list
        // this.$router.replace({ name: 'List PKO'})
        this.getList();
      } catch (e) {
        //panggil alert error
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong!"
        );
        this.setApiValidation(e.response.data.errors);
      }
    },

    searchButton() {
      this.searchValue = this.search;
      this.getList();
    },
    clearSearchButton() {
      this.searchValue = null;
      this.search = null;
      this.searchCategory = null;
      this.getList();
    },

    getFiltered(data) {
      this.exportDisplayedPage = this.dataExport(data);
    },

    // fungsi add data
    // addData() {
    //   // panggil add page
    //   this.$router.push({ name: "Add PKO Black Plate" });
    // },
    // replacementPko(id) {
    //   this.$router.push({ name: 'Replacement PKO Black Plate', params: {pko: id, id } })
    // },

    async dataExportBefore(type) {
      if (this.table.length != 0) {
        console.log("ewww");
        if (type == "all") {
          await this.$store.dispatch("fms_pko/list");
          return this.dataExport(
            await this.$store.getters["fms_pko/list"]
          );
        } else if (type == "filter") {
          var query = {};

          // if(sortBy.length!=0){
          //   var  sort=sortBy[0]
          //   if(sortDesc[0]){
          //     sort="-"+sortBy[0]
          //   }
          //   query.sort = sort
          // }

          if (this.searchValue && this.searchCategory) {
            if (query.filter) {
              Object.assign(query.filter, {
                [this.searchCategory]: this.searchValue,
              });
            } else {
              query.filter = { [this.searchCategory]: this.searchValue };
            }
          }

          if (this.valuePaymentPlan != 0) {
            if (query.filter) {
              Object.assign(query.filter, {
                payment_plan_name: this.valuePaymentPlan,
              });
            } else {
              query.filter = { payment_plan_name: this.valuePaymentPlan };
            }
          }

          if (this.valueStatus != "") {
            if (query.filter) {
              Object.assign(query.filter, { pko_status: this.valueStatus });
            } else {
              query.filter = { pko_status: this.valueStatus };
            }
          }

          if (this.valuePkoType != "") {
            if (query.filter) {
              Object.assign(query.filter, { pko_type: this.valuePkoType });
            } else {
              query.filter = { pko_type: this.valuePkoType };
            }
          }

          await this.$store.dispatch("fms_pko/list", query);
          return this.dataExport(
            await this.$store.getters["fms_pko/list"]
          );
        }
      }
    },

    //fungsi untuk mengubah data yang siap di export data ke xls, saat dipanggil di awal dan dipanggil berulang kali di fungsi filter
    dataExport(data) {
      var dataReturn = [];
      data.forEach((value_1, index_1) => {
        var pko_status = null;
        if (value_1.pko_status == 0) {
          pko_status = "Registered";
        } else if (value_1.pko_status == 1) {
          pko_status = "Waiting PKO";
        } else if (value_1.pko_status == 2) {
          pko_status = "Rejected";
        } else if (value_1.pko_status == 3) {
          pko_status = "Active";
        } else if (value_1.pko_status == 4) {
          pko_status = "Payment Completed";
        } else if (value_1.pko_status == 5) {
          pko_status = "Terminated by Payment";
        }
        // var business_unit = null
        // var driver_name = null
        // var driver_no = null
        // var vehicle_plate_no = null
        // var vehicle_door_no = null

        // if(value_1.business_unit){
        //   business_unit = value_1.pko_vehicle.vehicle_business_unit.business_unit_name
        // }

        // if(value_1.driver_name){
        //   driver_name = value_1.pko_driver.driver_name
        // }

        // if(value_1.driver_no){
        //   driver_no = value_1.pko_driver.driver_no
        // }
        // if(value_1.vehicle_plate_no){
        //   vehicle_plate_no = value_1.pko_vehicle.vehicle_plate_no
        // }
        // if(value_1.vehicle_door_no){
        //   vehicle_door_no = value_1.pko_vehicle.vehicle_door_no
        // }

        var data = {
          no: index_1 + 1,
          pko_no: value_1.pko_no,
          pko_start_date: value_1.pko_start_date,
          pko_total_payable: value_1.pko_total_payable,
          pko_status: pko_status,
          pko_remark: value_1.pko_remark,
          payment_plan: (value_1.pko_payment_plant)?value_1.pko_payment_plant.payment_plan_name:null,
          
          vehicle_plate_no: value_1.pko_vehicle
            ? value_1.pko_vehicle.vehicle_plate_no
            : "",
          vehicle_door_no: value_1.pko_vehicle
            ? value_1.pko_vehicle.vehicle_door_no
            : "",
          driver_no: value_1.pko_driver ? value_1.pko_driver.driver_no : "",
          driver_name: value_1.pko_driver ? value_1.pko_driver.driver_name : "",
          created_at: value_1.created_at,
          updated_at: value_1.updated_at,
        };

        dataReturn.push(data);
      });
      return dataReturn;

      // console.log(data)
    },

    async downloadAgreementDoc(id, item) {
      await this.$store.dispatch(
        "fms_pko/download_doc_agreement",
        id
      );
      // = await this.$store.getters["fms_pko/blob"];
      var fileURL = window.URL.createObjectURL(
        new Blob([await this.$store.getters["fms_pko/blob"]])
      );
      var fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute("download", "Agreement " + item.pko_no +" "+item.pko_driver.driver_name+" "+ item.pko_vehicle.vehicle_plate_no+ ".docx");
      document.body.appendChild(fileLink);

      fileLink.click();
    },
  },
};
</script>
<style>
#pro-feature {
  font-weight: bold;
}
</style>
